// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PaymentFeatures_wrapper__jK0dc","icon":"PaymentFeatures_icon__MgXb_","item":"PaymentFeatures_item__OL4uw"};